<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PrintOrderControl',

  props: {
    sortFields: { required: true, type: Array as () => string[] },
    sortDesc: { required: true, type: Boolean },
    fields: { required: true, type: Array as () => string[] },
    disabled: { required: false, type: Boolean, default: false }
  }
})
</script>

<template>
  <v-row align="center">
    <v-col cols="3">
      Print order:
    </v-col>
    <v-col>
      <v-select
        multiple
        :value="sortFields"
        @input="$emit('update:sortFields', $event)"
        :items="fields"
        :disabled="disabled"
        placeholder="Select fields"
        hide-details
        outlined
        dense
        background-color="#FFFFFF"
      >
        <template v-slot:selection="{ item, index }">
          <span v-if="index > 0">→</span>
          <v-chip small>
            <span>{{ item }}</span>
          </v-chip>
        </template>
      </v-select>
    </v-col>
    <v-col>
      <v-btn-toggle :value="sortDesc" @change="$emit('update:sortDesc', $event)" mandatory dense :disabled="disabled">
        <v-btn :value="false">
          <v-icon class="mr-1">mdi-sort-ascending</v-icon>
          A to Z
        </v-btn>
        <v-btn :value="true">
          <v-icon class="mr-1">mdi-sort-descending</v-icon>
          Z to A
        </v-btn>
      </v-btn-toggle>
    </v-col>
  </v-row>
</template>

<style scoped>
.v-btn-toggle > .v-btn {
  text-transform: none;
}

.v-btn-toggle > .v-btn.v-btn--active {
  background-color: var(--a2z-primary) !important;
}

.v-btn-toggle > .v-btn.v-btn--active,
.v-btn-toggle > .v-btn.v-btn--active ::v-deep .v-icon {
  color: #FFFFFF !important;
}
</style>
